import { useTranslation } from "react-i18next"
import { Box, Checkbox, GridLayout, Typography } from "@strapi/design-system"

interface ConfigurationCustomizeProps {
  data: any
  onChange: (data: any) => void
  onValid: (valid: boolean) => void
}

export const ConfigurationCustomize = ({
  data,
  onChange,
  onValid: _onValid,
}: ConfigurationCustomizeProps) => {
  const { t } = useTranslation()
  const customizeSection = {
    key: "customize",
    title: t("configurationCustomize.title"),
    type: "checkbox",
    list: [
      {
        key: "useLegacyLabelling",
        title: t("configurationCustomize.useLegacyLabelling"),
      },
    ],
  }

  return (
    <Box padding={6} background="neutral0" hasRadius>
      <Typography variant="beta">{customizeSection.title}</Typography>
      <Box padding={2} />
      <GridLayout>
        {customizeSection.list.map(({ key, title }) => (
          <Checkbox
            key={key}
            checked={data.config[key] || false}
            onChange={() => {
              const updatedConfig = {
                ...data.config,
                [key]: !data.config[key],
              }
              onChange({
                ...data,
                config: updatedConfig,
              })
            }}
          >
            {title}
          </Checkbox>
        ))}
      </GridLayout>
    </Box>
  )
}
